(function () {
  'use strict';

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[char];
    });
  }

  var reviewObservers = new Map();
  function initRecentReviewLabels(root) {
    if (!document.body.classList.contains('template-product')) return;
    var sections = Array.from(root.querySelectorAll('[data-section-type="recently-viewed"]'));
    if (root.matches && root.matches('[data-section-type="recently-viewed"]')) sections.push(root);
    sections.forEach(function (section) {
      if (reviewObservers.has(section)) return;
      function format() {
        section.querySelectorAll('.jdgm-badge-placeholder').forEach(function (badge) {
          var preview = badge.querySelector('.jdgm-prev-badge');
          var count = preview && preview.getAttribute('data-number-of-reviews');
          var hasReviews = /^\d+$/.test(count || '') && Number(count) > 0;
          badge.classList.toggle('libas-no-reviews', !hasReviews);
          var text = preview && preview.querySelector('.jdgm-prev-badge__text');
          var stars = preview && preview.querySelector('.jdgm-prev-badge__stars');
          var rating = Number.parseFloat(preview && preview.getAttribute('data-average-rating'));
          if (stars && Number.isFinite(rating)) {
            var score = rating.toFixed(1);
            if (stars.dataset.score !== score) stars.dataset.score = score;
          }
          var label = '(' + count + ')';
          if (hasReviews && text && text.textContent !== label) text.textContent = label;
        });
      }
      var observer = new MutationObserver(format);
      observer.observe(section, {childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-number-of-reviews', 'data-average-rating']});
      reviewObservers.set(section, observer);
      format();
    });
  }

  function initUsps(root) {
    root.querySelectorAll('.libas-usp-slider').forEach(function (slider) {
      if (slider.dataset.ready) return;
      slider.dataset.ready = 'true';
      var slides = Array.from(slider.querySelectorAll('.libas-usp-slide'));
      var dots = Array.from(slider.querySelectorAll('[data-usp-dot]'));
      var pause = slider.querySelector('[data-usp-pause]');
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var paused = reducedMotion.matches;
      var index = 0;
      function show(next) {
        index = next % slides.length;
        slides.forEach(function (slide, i) {
          slide.setAttribute('aria-hidden', String(i !== index));
          slide.inert = i !== index;
        });
        dots.forEach(function (dot, i) { dot.setAttribute('aria-pressed', String(i === index)); });
      }
      function updatePause() {
        pause.setAttribute('aria-label', paused ? 'Play slides' : 'Pause slides');
        pause.title = paused ? 'Play slides' : 'Pause slides';
        pause.querySelector('path').setAttribute('d', paused ? 'M8 5l11 7-11 7Z' : 'M8 5v14M16 5v14');
      }
      dots.forEach(function (dot, i) { dot.addEventListener('click', function () { show(i); }); });
      pause.addEventListener('click', function () { paused = !paused; updatePause(); });
      reducedMotion.addEventListener('change', function (event) { paused = event.matches; updatePause(); });
      updatePause();
      var timer = window.setInterval(function () {
        if (!slider.isConnected) return window.clearInterval(timer);
        if (!paused && !document.hidden && !slider.matches(':hover') && !slider.contains(document.activeElement)) show(index + 1);
      }, 5000);
    });
  }

  if (window.theme) {
    // Recently viewed and search use this renderer; group the whole price before adding delivery stamps.
    theme.buildProductGridItem = function (products, gridClass, row, sizes) {
      return products.map(function (product) {
        var price = Number(product.price || 0);
        var compare = Number(product.compare_at_price || 0);
        var money = function (amount) { return theme.Currency.formatMoney(amount, theme.moneyFormat); };
        var prices = compare > price ? '<span class="grid-product__price--original">' + money(compare) + '</span> ' : '';
        prices += '<span class="grid-product__price--current">' + money(price) + '</span>';
        if (compare > price) prices += ' <span class="grid-product__price--savings">' + Math.round((compare - price) * 100 / compare) + '% off</span>';
        return '<div class="grid__item grid-product ' + escapeHtml(gridClass) + ' aos-animate" data-aos="row-of-' + escapeHtml(row) + '">' +
          '<div class="grid-product__content"><a href="' + escapeHtml(product.url) + '" class="grid-product__link">' +
          '<div class="grid-product__image-mask">' + theme.buildProductImage(product, sizes) + '</div>' +
          '<div class="grid-product__meta"><div class="grid-product__title">' + escapeHtml(product.title) + '</div>' +
          '<div class="jdgm-badge-placeholder" data-handle="' + escapeHtml(product.handle) + '"></div>' +
          '<div class="grid-product__price">' + prices + '</div></div></a></div></div>';
      }).join('');
    };
  }

  // Quantity writes and delivery-property writes must not overwrite one another.
  var tail = Promise.resolve();
  var pendingQuantities = new Map();
  window.LibasCartUpdates = {
    flush: function () {
      Array.from(pendingQuantities.values()).forEach(function (run) { run(); });
      return tail;
    },
    run: function (task) {
      var result = tail.catch(function () {}).then(task);
      tail = result.catch(function () {});
      return result;
    }
  };

  if (window.theme && theme.CartForm) {
    theme.CartForm.prototype.quantityChanged = function (event) {
      var instance = this;
      var wrapper = event.detail[2];
      var quantity = Number(event.detail[1]);
      if (!event.detail[0] || !Number.isInteger(quantity) || quantity < 0 || !wrapper) return;
      window.clearTimeout(wrapper.__libasQuantityTimer);
      function enqueueQuantity() {
        window.clearTimeout(wrapper.__libasQuantityTimer);
        pendingQuantities.delete(wrapper);
        window.LibasCartUpdates.run(async function () {
          var input = wrapper.querySelector('input');
          if (!wrapper.isConnected) {
            input = Array.from(instance.form.querySelectorAll('.js-qty__num')).find(function (field) { return field.dataset.id === event.detail[0]; });
            if (input) wrapper = input.closest('.js-qty__wrapper');
          }
          if (!input || !wrapper || !wrapper.isConnected) return;
          var key = input.dataset.id || event.detail[0];
          var controls = Array.from(document.querySelectorAll('.js-qty__adjust, .js-qty__num'));
          var disabled = controls.map(function (control) { return control.disabled; });
          controls.forEach(function (control) { control.disabled = true; });
          wrapper.classList.add('is-loading');
          instance.form.querySelectorAll('.libas-cart-error').forEach(function (node) { node.remove(); });
          try {
            var response = await window.fetch(theme.routes.cartChange, {
              method: 'POST', credentials: 'same-origin',
              headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
              body: JSON.stringify({id: key, quantity: quantity, sections: ['libas-cart-items'], sections_url: theme.routes.cartPage})
            });
            var cart = await response.json();
            if (!response.ok || cart.status) throw new Error(cart.description || cart.message || 'Unable to update quantity. Please try again.');
            var html = cart.sections && cart.sections['libas-cart-items'];
            // Section rendering can fail independently of a successful cart change. Never retry the write.
            if (!html || !html.includes('class="cart__items"')) html = await theme.cart.getCartProductMarkup();
            instance.cartItemsUpdated = !cart.items.some(function (item) { return item.key === key; });
            instance.cartMarkup(html);
            document.dispatchEvent(new CustomEvent('cart:updated', {detail: {cart: cart}}));
          } catch (error) {
            var message = document.createElement('p');
            message.className = 'libas-cart-error';
            message.setAttribute('role', 'alert');
            message.textContent = error.message || 'Unable to update quantity. Please try again.';
            instance.products.before(message);
            try { instance.cartMarkup(await theme.cart.getCartProductMarkup()); } catch (refreshError) {}
          } finally {
            wrapper.classList.remove('is-loading');
            controls.forEach(function (control, i) { if (control.isConnected) control.disabled = disabled[i]; });
          }
        });
      }
      pendingQuantities.set(wrapper, enqueueQuantity);
      wrapper.__libasQuantityTimer = window.setTimeout(enqueueQuantity, 120);
    };

    // The theme can bind its original method before this deferred asset runs.
    // Route those already-bound events through the same updated implementation.
    ['cart-drawer', 'page', 'header'].forEach(function (location) {
      document.addEventListener('cart:quantity.cart-' + location, function (event) {
        var wrapper = event.detail && event.detail[2];
        var form = wrapper && wrapper.closest('form');
        var instance = form && form.__diCartFormInstance;
        if (!instance) return;
        event.stopImmediatePropagation();
        theme.CartForm.prototype.quantityChanged.call(instance, event);
      }, true);
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initUsps(document); initRecentReviewLabels(document); });
  document.addEventListener('shopify:section:load', function (event) { initUsps(event.target); initRecentReviewLabels(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    reviewObservers.forEach(function (observer, section) {
      if (section === event.target || event.target.contains(section)) {
        observer.disconnect();
        reviewObservers.delete(section);
      }
    });
  });
})();
